module.exports = __webpack_public_path__ + "static/media/align-h-center.31b8437d.svg";